import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import dayjs from 'dayjs';
import {InAppNotification} from '@app/interfaces/entities/in-app-notification';
import {NotificationApiService} from '@app/services/api/notification-api.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class NotificationComponent implements OnInit {
  @Input() notification: InAppNotification;
  @Input() showCloseMark = false;
  @Input() loudNotification = false;
  @Output() onClose = new EventEmitter();

  public notificationType: string = NotificationType.NORMAL;
  public createdAt: string;
  public isExpanded = false;
  public readonly TRUNCATE_LENGTH = 150;

  constructor(public router: Router,
              private notificationApiService: NotificationApiService) {
  }

  ngOnInit(): void {
    this.createdAt = dayjs(this.notification.created_at).fromNow();

    this.setNotificationType(this.notification);
  }

  removeNotification() {
    this.onClose.emit(this.notification.id);
    this.notificationApiService.markNotificationRead(this.notification.id).subscribe();
  }

  redirectToNotification(notification: InAppNotification) {
    // Starts with http/https
    if (RegExp('https?').test(notification.data.button_link)) {
      window.open(notification.data.button_link, '_blank');
    } else {
      this.router.navigateByUrl(`admin/${notification.data.button_link}`);
    }
    this.onClose.emit(this.notification.id);
    this.notificationApiService.markNotificationRead(this.notification.id).subscribe();
  }

  toggleExpanded(event: Event) {
    event.stopPropagation();
    this.isExpanded = !this.isExpanded;
  }

  private get content(): string {
    return this.notification.data.push_content || this.notification.data.notification_content || '';
  }

  getDisplayContent(): string {
    const content: string = this.content;
    const plainText: string = this.stripHtmlTags(content);

    if (this.isExpanded || plainText.length <= this.TRUNCATE_LENGTH) {
      return content;
    }

    const truncatedText: string = plainText.substring(0, this.TRUNCATE_LENGTH) + '...';
    return `<span>${this.escapeHtml(truncatedText)}</span>`;
  }

  private escapeHtml(text: string): string {
    const div: HTMLDivElement = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  shouldShowExpandToggle(): boolean {
    const plainText: string = this.stripHtmlTags(this.content);
    return plainText.length > this.TRUNCATE_LENGTH;
  }

  private stripHtmlTags(html: string): string {
    const tmp: HTMLElement = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  private setNotificationType(notification: InAppNotification) {
    if (notification.data.type) {
      this.notificationType = notification.data.type;
    }
  }
}

export enum NotificationType {
  NORMAL = 'normal',
  INFORMATION = 'information',
  ALERT = 'alert'
}
